import { useTranslation } from "react-i18next";
import { NeuCard } from "../../components/neu/Neu";

const KEYS = ["employees", "checked_in", "checked_out", "late", "absent"];
const LEGEND = [
  ["person", "#3b82f6"],
  ["late", "#ef4444"],
  ["out", "#94a3b8"],
  ["branch", "#22c55e"],
  ["duty", "#f59e0b"],
];

export const LiveStats = ({ totals, date }) => {
  const { t } = useTranslation();

  return (
    <NeuCard className="grid gap-4 p-4" data-testid="live-stats">
      <div className="flex flex-wrap items-center justify-between gap-3">
        <p className="label-xs">{t("live.today")}</p>
        <span className="font-mono text-xs text-muted-foreground" dir="ltr">{date}</span>
      </div>
      <dl className="grid grid-cols-2 gap-3 sm:grid-cols-5">
        {KEYS.map((key) => (
          <div key={key} className="rounded-2xl px-3 py-2 shadow-neu-in">
            <dt className="text-[10px] text-muted-foreground">{t(`live.totals.${key}`)}</dt>
            <dd className="mt-1 font-mono text-lg font-black" data-testid={`live-total-${key}`}>
              {totals?.[key] ?? 0}
            </dd>
          </div>
        ))}
      </dl>
      <div className="flex flex-wrap gap-3">
        {LEGEND.map(([key, color]) => (
          <span key={key} className="flex items-center gap-1.5 text-[11px] text-muted-foreground">
            <span className="h-2.5 w-2.5 rounded-full" style={{ background: color }} />
            {t(`live.legend.${key}`)}
          </span>
        ))}
      </div>
    </NeuCard>
  );
};
